import { fetchWrapper } from "utils/apiFetch";

const API_BASE = "https://pro.mokshiq.in";

/**
 * Normalizes backend responses from GET (PascalCase) and GETBYID (snake_case)
 * into consistent camelCase properties for React UI components.
 */
export const normalizeExtraService = (item) => {
  if (!item) return null;
  return {
    id: item.id,
    name: item.Name || item.name || "",
    category: item.Category || item.category || "",
    description: item.Description || item.description || "",
    image: item.Image || item.image || null,
    materialClick: item["Material Click"] || item.material_click || "",
    webUrl: item["Web URL"] || item.web_url || "",
    status:
      typeof item.Status !== "undefined"
        ? String(item.Status).toLowerCase() === "true" || item.Status === true || item.Status === 1
        : String(item.status).toLowerCase() === "true" || item.status === true || item.status === 1,
    createdBy: item["Created By"] || item.created_by || null,
  };
};

export const extraService = {
  // 1. GET ALL EXTRA SERVICES
  getAll: async (companyId = null) => {
    const formData = new FormData();
    formData.append("action", "GET");
    if (companyId) {
      formData.append("company", companyId);
    }

    try {
      const res = await fetchWrapper(`${API_BASE}/extra_service_action`, {
        method: "POST",
        body: formData,
      });
      const rawList = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      return { status: true, data: rawList.map(normalizeExtraService) };
    } catch (err) {
      console.warn("Could not fetch extra services from server:", err);
      return { status: false, message: err.message || "Failed to fetch extra services", data: [] };
    }
  },

  // 2. GET EXTRA SERVICE BY ID
  getById: async (id) => {
    const formData = new FormData();
    formData.append("action", "GETBYID");
    formData.append("id", id);

    try {
      const res = await fetchWrapper(`${API_BASE}/extra_service_action`, {
        method: "POST",
        body: formData,
      });
      if (res?.status && res?.data) {
        return { status: true, data: normalizeExtraService(res.data) };
      }
      return { status: false, message: res?.message || res?.data || "Service not found" };
    } catch (err) {
      return { status: false, message: err.message || "Failed to fetch service details" };
    }
  },

  // 3. ADD OR UPDATE EXTRA SERVICE
  addOrUpdate: async (serviceData, imageFile = null) => {
    const formData = new FormData();
    formData.append("action", "ADDUpdate");

    if (serviceData.id) {
      formData.append("id", serviceData.id);
    }

    formData.append("name", serviceData.name || "");
    formData.append("category", serviceData.category || "");
    formData.append("description", serviceData.description || "");
    formData.append("material_click", serviceData.materialClick || "");
    formData.append("web_url", serviceData.webUrl || "");
    formData.append("status", serviceData.status ? "true" : "false");

    if (imageFile instanceof File) {
      formData.append("image", imageFile);
    }

    try {
      const res = await fetchWrapper(`${API_BASE}/extra_service_action`, {
        method: "POST",
        body: formData,
      });
      if (res && res.status !== false) {
        return {
          status: true,
          message: typeof res.data === "string" ? res.data : serviceData.id ? "Updated Successfully" : "Added Successfully",
        };
      }
      return { status: false, message: typeof res?.data === "string" ? res.data : res?.message || "Operation failed" };
    } catch (err) {
      return { status: false, message: err.message || "Operation failed" };
    }
  },

  // 4. DELETE EXTRA SERVICE
  remove: async (id) => {
    const formData = new FormData();
    formData.append("action", "DELETE");
    formData.append("id", id);

    try {
      const res = await fetchWrapper(`${API_BASE}/extra_service_action`, {
        method: "POST",
        body: formData,
      });
      if (res && res.status !== false) {
        return {
          status: true,
          message: typeof res.data === "string" ? res.data : "Deleted Successfully",
        };
      }
      return { status: false, message: typeof res?.data === "string" ? res.data : res?.message || "Delete failed" };
    } catch (err) {
      return { status: false, message: err.message || "Delete failed" };
    }
  },
};

export default extraService;
